import React, { createContext, useContext } from 'react';

export type ThemeMode = 'light' | 'dark';

export const ThemeContext = createContext<{
  theme: ThemeMode;
  toggleTheme: () => void;
}>({
  theme: 'light',
  toggleTheme: () => {},
});

export function useTheme() {
  return useContext(ThemeContext);
}
